import Manager, { hasPermission } from './manager'

function install(Vue) {
  Vue.component('PermissionManager', Manager)

  // Mixin 本身太过于灵活，太依赖使用者，很容易出现问题，特别是做全局混入对象时，一定要非常慎重
  // 谨慎使用全局混入对象，因为会影响到每个单独创建的 Vue 实例 (包括第三方模板)
  Vue.mixin({
    methods: {
      hasPermission
    }
  })
}

export default {
  install
}
